
const _ = require('lodash');

const vb = require('./definition');


vb.custom = (validator, options) => {
	if (_.isString(options)
		|| _.isArray(options)
		|| _.isFunction(options)
	) {
		options = { message: options };
	}

	options = _.defaults({}, options, {
		message: [
			'заполнено неверно',
			'неверно',
		],
	});

	return {
		validator,
		message: options.message,
	};
};

vb.valid = _.once(_.partial(vb.custom, _.constant(true)));
vb.invalid = _.once(_.partial(vb.custom, _.constant(false)));

